<template>
    <div class="info">
        <Header HeaderTitle="Welcome to The INbox" />
        <p>
            To allow your viewers to add questions, you will need to setup your chatbot so that they can run a command with their question. Utilise one of the below for the bot that you use! Please remember to replace <code>YOURUSERNAME</code> with your Twitch/Mixer username
        </p>
        <br />
        <br />
        <ul>
            <li>
                <b>
                    Nightbot:
                </b>
                <code>
                    $(urlfetch https://api.itslit.uk/Questions/add/YOURUSERNAME/$(user)/$(querystring))
                </code>
            </li>
            <li>
                <b>
                    StreamLabs Chatbot:
                </b>
                <code>
                    $readapi(https://api.itslit.uk/Questions/add/$mychannel/$username/$msg)
                </code>
            </li>
            <li>
                <b>
                    StreamElements:
                </b>
                <code>
                    ${customapi.api.itslit.uk/Questions/add/${channel}/${user}/${queryescape})
                </code>
            </li>
        </ul>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Header from '../components/layout/Header';

    export default {
        name: 'Info',
        components: {
            Header
        }
    }
</script>

<style scoped>
    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
    }

    body {
        font-family: Arial, Helvetica, sans-serif;
        line-height: 1.4;
    }
</style>
